/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:d37a21e9-2027-4704-a4a1-882d1dc59d4e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_c9VhG0hPq",
    "aws_user_pools_web_client_id": "70hmd4g4ekv4gog7oqh6o0uih9",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NICKNAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://odvfmktsozdudg6ryxc7tndrom.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-p276yvefy5e2lmg4gcprh52dbm",
    "aws_user_files_s3_bucket": "mobiusevo09userfiles160754-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
